import React, {Component} from 'react';
import PropTypes from 'prop-types';
import TransferContentsTableRow from '../components/TransferContentsTableRow';
import {Card, CardHeader} from 'material-ui/Card';
import {
    Table,
    TableHeader,
    TableHeaderColumn,
    TableRow,
    TableRowColumn,
    TableBody
} from "material-ui";
import FuseTheme from "../global/theme";

/**
 * A component for generating rows of Transfer items within a collection.
 *
 */
class TransferTable extends Component {
    constructor(props) {
        super(props);
        this.state = {
            collection: [],
            showContents: false,
        };
    }

    componentWillMount() {
        if (this.record && this.record.contents) {
            this.setState({
                collection: this.record.contents
            });
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.record !== this.props.record) {
            if (nextProps.record.contents) {
                this.setState({
                    collection: nextProps.record.contents
                });
            }
        }
    }

    // Handle event to display/hide Collection
    handleToggleClick = (e, toggle) => {
        this.setState({
            showContents: toggle,
        });
    };

    // Create rows of Products with icons and content
    makeTransferContentsTable = () => {
        const list = this.props.record.contents;
        const styles = {
            iconColumn: {padding: '0 14px'},
        };
        if (!list || list.length === 0 || !list.length) {
            return (
                <TableRow>
                    <TableRowColumn colSpan={7}>No Contents for this Transfer</TableRowColumn>
                    <TableRowColumn style={styles.iconColumn}>&nbsp;</TableRowColumn>
                </TableRow>
            )
        }
        return (
            list.map((item, index) => (
                <TransferContentsTableRow
                    key={item.barcode.toString() + index}
                    data={item}
                />
            ))
        )
    };

    render() {
        const styles = {
            fieldDescription: {
                display: 'block',
                width: '100%',
                fontSize: '14px',
                color: FuseTheme.palette.lightTextColor,
                margin: '0 0 1em 0',
            },
            iconColumn: {padding: '0 14px'},
            itemContainer: {
                margin: '0.5em 0 0 36px',
                padding: '0.5em 0 0 0',
                borderTop: '1px solid ' + FuseTheme.palette.accent2Color,
                borderBottom: '1px solid ' + FuseTheme.palette.accent2Color,
                verticalAlign: 'top',
                boxSizing: 'border-box',
            },
            tableCard: {display: 'block', margin: '1em 0 0 0'},
        };
        return (
            <Card style={styles.tableCard}>
                <CardHeader title="Transfer Contents"/>
                <Table selectable={false} multiSelectable={false}>
                    <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
                        <TableRow>
                            <TableHeaderColumn colSpan={2}>Barcode</TableHeaderColumn>
                            <TableHeaderColumn colSpan={2}>Product</TableHeaderColumn>
                            <TableHeaderColumn>Unit Type</TableHeaderColumn>
                            <TableHeaderColumn>Qty of Units</TableHeaderColumn>
                            <TableHeaderColumn style={styles.iconColumn}>View Contents</TableHeaderColumn>
                        </TableRow>
                    </TableHeader>
                    <TableBody displayRowCheckbox={false}>
                        {[...this.makeTransferContentsTable()]}
                    </TableBody>
                </Table>
            </Card>
        )
    }
}

TransferTable.propTypes = {
    addField: PropTypes.bool,
    label: PropTypes.string,
    record: PropTypes.object,
};

TransferTable.defaultProps = {
    addField: true,
};

export default TransferTable;



// WEBPACK FOOTER //
// ./src/Fuse/components/TransferTable.js